import './_navigation-mobile.scss';
import component from './navigation-mobile';

export default component;
